import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { appVersion } from '../../utils/version';

interface ThemeConfigLike {
  companyName?: string;
  companyUrl?: string;
  footerBrandLogo?: string;
  logo?: string;
  icon?: string;
  footerPoweredByText?: string;
}

interface FooterProps {
  drawerOpen: boolean;
  themeConfig: ThemeConfigLike | null | undefined;
}

export default function WelllynxFooter({ drawerOpen, themeConfig }: FooterProps) {
  const brandImage = themeConfig?.footerBrandLogo || themeConfig?.logo || themeConfig?.icon;
  const companyName = themeConfig?.companyName || '';
  const companyUrl = themeConfig?.companyUrl || '#';
  const poweredByText = themeConfig?.footerPoweredByText || 'Powered by';
  const year = new Date().getFullYear();
  const isSvg = typeof brandImage === 'string' && brandImage.toLowerCase().endsWith('.svg');

  return (
    <Box
      sx={{
        height: 36,
        borderTop: '1px solid #eee',
        backgroundColor: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2,
        flexShrink: 0,
      }}
    >
      <Typography variant="caption" color="textSecondary" sx={{ fontSize: '0.7rem' }}>
        <Link href={companyUrl} target="_blank" rel="noopener" underline="hover">
          {companyName}
        </Link>{' '}
        © {year}. All Rights Reserved. Version {appVersion}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
        <Typography variant="caption" color="textSecondary" sx={{ fontSize: '0.7rem' }}>
          {poweredByText}
        </Typography>
        {brandImage && (
          isSvg ? (
            <object
              data={brandImage}
              type="image/svg+xml"
              aria-label={companyName}
              style={{ width: 140, height: 20, display: 'block' }}
            />
          ) : (
            <img src={brandImage} alt="brand" style={{ height: 20, width: 'auto', display: 'block' }} />
          )
        )}
      </Box>
    </Box>
  );
}

